<template>
  <div class="home">
    <div id="sources">
      <h3 style="text-align: center">Industries and companies</h3>

      <!-- Render each group -->
      <div
        v-for="(item, index) in dashboard"
        :key="index"
        class="row"
        :id="index"
      >
        <div class="col-md-12 title" @click="showClass(index)">
          
          <router-link :to="'/industry/'+item.group">📦Group {{ index + 1 }}: {{ item.group }}</router-link>
        </div>

        <!-- Render each company card in the group -->
        <div
          v-for="(company, index) in item.companies"
          :key="index"
          class="col-md-4"
        >
          <CompanyCard
            v-if="!company.hide"
            :real_name="company.real_name"
            :nick_name="company.nick_name"
            :source="company.source"
          ></CompanyCard>
          <data v-if="company.hide" >
            
            <p style="text-center; padding: 20px;">
             <i> There are not enough amount of customer reviews for the topic {{ company.nick_name }}</i>
            </p>
          </data>
           
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import component named CompanyCard
import CompanyCard from "@/components/CompanyCard.vue";

export default {
  name: "CompanyList",
  components: {
    CompanyCard,
  },
  data() {
    return {
      groups: [],
      dashboard: [],
      visible_groups: [],
    };
  },
  methods: {
    fetchData() {
      try {
        this.dashboard = require("@/assets/dashboard.json"); // Adjust the file path
        this.groups = this.dashboard.map((x) => x.group);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    showClass(classNumber) {
      for (let i = 0; i < this.groups.length; i++) {
        this.visible_groups[i] = false;
      }
      // console.log(this.visible_groups);
      this.visible_groups[classNumber] = true;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.row {
  border: solid 1px #65123b;
  margin-bottom: 10px;
  border-radius: 10px;
  padding-left: 10px;
}

.title {
  cursor: pointer;
}
</style>
